import { render } from "./PlotTaskPage.vue?vue&type=template&id=018b007d&ts=true"
import script from "./PlotTaskPage.ts?vue&type=script&lang=ts&external"
export * from "./PlotTaskPage.ts?vue&type=script&lang=ts&external"

import "./PlotTaskPage.vue?vue&type=style&index=0&id=018b007d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__